import Header from 'components/_OldDesign/header'
import React, { ReactElement, useEffect, useState } from 'react'
import style from 'styles/Content.module.scss'
import { GetStaticProps } from 'next';
import 'react-multi-carousel/lib/styles.css';
import { strapi } from 'models/conent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faSearch } from '@fortawesome/free-solid-svg-icons';
import { translate } from 'utils/translate';
import Link from 'next/link';
import { NextPageWithLayout } from './_app';
import OldLayout from '@components/_OldDesign/OldLayout';
import fetchStrapi from 'lib/fetchStrapi';
import { Lang, useLocale } from '@components/Contexts/LocaleContext';
import { omitDeep } from 'lodash-omitdeep';

export const getStaticProps: GetStaticProps = async () => {
  try {
    let issues = await fetchStrapi('/issues', 2);
    issues = omitDeep(issues, ['blogs', 'formats']);
    return {
      props: {
        issues
      },
    };
  } catch (error) {
    return {
      props: {
        data: JSON.stringify(error),
      },
    };
  }
}

const Issues: NextPageWithLayout<{ issues: any }> = ({ issues }) => {
  const [content, setContent] = useState(null);
  const [search, setSearch] = useState<string>('')
  const {lang, setLang} = useLocale();

  const searchByTitle = (search: string) => {
    if (!search) {
      setContent(issues);
    }
    const item = issues.filter(content => {
      return content.theme.toLowerCase().includes(search.toLowerCase());
    });
    setContent(item);
  }

  useEffect(() => {
    setContent(issues);
    setLang((localStorage.getItem('lang') ?? 'th') as Lang);
  }, [])

  return <>
    <div className="px-12 xl:px-24">
      <Header content={ {
        content: 'ข่าวสารความรู้ทางด้านเทคโนโลยี และการบริหารธุรกิจด้วยไอทีในทุกด้าน',
        title: 'ข่าวสารความรู้ทางด้านเทคโนโลยี และการบริหารธุรกิจด้วยไอทีในทุกด้าน',
        image: null
      } }/>

      <div className={ `h-full w-full relative pt-40 pb-12 xl:pt-24` }>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20">
          <div className="grid grid-cols-3 align-self-center">
            <Link href="/blogs">
              <div className="border-dark-blue border-2 text-center py-4 md:py-1 cursor-pointer rounded-l-xl">
                <span className="text-4xl md:text-xl lg:text-2xl underline">Blogs</span>
              </div>            
            </Link>
            <div
              className="border-dark-blue bg-dark-blue border-t-2 border-b-2 text-white text-center py-4 md:py-1 cursor-pointer ">
              <span className="text-4xl md:text-xl lg:text-2xl">Issues</span>
            </div>
            <Link href="/categories">
              <div className="border-dark-blue border-2 text-center py-4 md:py-1 cursor-pointer rounded-r-xl">
                <span className="text-4xl md:text-xl lg:text-2xl underline">Categories</span>
              </div>
            </Link>
          </div>
          <div className="relative">
            <input type="text"
              className={ `${ style.outlineNone } ${ style.search } xl:m-auto bg-white border-b w-full lg:mx-8 border-dark-blue px-2 text-dark-blue h-20 lg:h-12 text-2xl md:text-xl lg:text-2xl` }
              placeholder="Search Theme" value={ search } onChange={ (e) => {
              setSearch(e.target.value)
              searchByTitle(e.target.value);
            } }/>
            <FontAwesomeIcon icon={ faSearch } className="absolute right-3 text-2xl fa-2x top-5 lg:top-2 text-dark-blue"/>
          </div>
        </div>
      </div>

      <div className="mb-44 lg:mb-60">
        { content?.sort((a, b) => a.id < b.id ? -1 : 1).map((item, i) =>
            <span key={ i }>
            <div className="grid grid-cols-1 md:grid-cols-2 mb-10">
              <img className="h-full max-h-96 w-full mb-10" alt={ item.theme } src={ strapi + item.image?.url }/>
              <div className={ `md:px-10 ${ i % 2 !== 0 ? 'order-last md:order-first' : '' }` }>
                <div className="grid grid-cols-3 align-self-center w-full">
                  <div
                    className="bg-dark-blue border-dark-blue border-2 2xl:border-4 text-center text-white py-4 md:py-1">
                    <span className="text-3xl md:text-lg lg:text-xl">Issues</span>
                  </div>
                  <div className="col-span-2 border-dark-blue border-2 2xl:border-4 text-center py-4 md:py-1">
                    <span className="text-3xl md:text-lg lg:text-xl">{ item.month }</span>
                  </div>
                  <Link href={ '/issues/' + item.id + '-' + item.theme }>
                    <div
                      className="col-span-3 border-dark-blue border-t-0 border-2 2xl:border-4 2xl:border-t-0 text-center py-5 sm:py-3 2xl:py-2">
                      <span className="text-5xl md:text-4xl 2xl:text-3xl cursor-pointer">{ item.theme }</span>
                    </div>
                  </Link>
                </div>
                <div className="mt-7 lg:mt-5">
                  <span
                    className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(item, 'description', lang) }</span>
                  <Link href={ '/issues/' + item.id + '-' + item.theme } key={ i }>
                    <div className="my-8 lg:my-5 text-5xl sm:text-3xl lg:text-2xl font-bold cursor-pointer">
                      READ NOW <FontAwesomeIcon className="fa-1x" icon={ faArrowRight }/>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          <hr className={ `${ i < content?.length - 1 ? '' : 'hidden' } border-gray-400 my-12` }/>
        </span>
        ) }
      </div>
    </div>

  </>
}

Issues.getLayout = (page: ReactElement) => {
  return <OldLayout>{page}</OldLayout>;
};

export default Issues;
